import PropTypes from 'prop-types';

import AddressPropType from './address';
import BrandingsPropType from './brandings';
import CustomPropertyPropType from './custom-property';
import FeaturePropType from './feature';
import FuelTypePropType from './fuel-type';
import EmergencyStatusPropType from './emergency-status';
import SolutionPropType from './solution';
import OpeningHoursPropType from './opening-hours';

export const Station = PropTypes.shape({
  id: PropTypes.number,
  retailer_reference: PropTypes.string,
  retailer_name: PropTypes.string,
  status: PropTypes.string,
  watched: PropTypes.bool,
  display_name: PropTypes.string,
  brand_id: PropTypes.number,
  brand_logo_url: PropTypes.string,
  latitude: PropTypes.number,
  longitude: PropTypes.number,
  open_status: PropTypes.string,
  open_status_display_name: PropTypes.string,
  phone_number: PropTypes.string,
  address: AddressPropType,
  brandings: BrandingsPropType,
  opening_hours: OpeningHoursPropType,
  custom_properties: PropTypes.arrayOf(CustomPropertyPropType),
  features: PropTypes.arrayOf(FeaturePropType),
  fuel_types: PropTypes.arrayOf(FuelTypePropType),
  emergency_status: PropTypes.arrayOf(EmergencyStatusPropType),
  solutions: PropTypes.arrayOf(SolutionPropType),
});

export default Station;
